import { createContext } from 'react';

export const ExperienceEditorContext = createContext(null);